<template>
  <v-row class="visit-summary-header" justify="space-between">
    <v-col class="visit-summary-header_left"
      ><img class="visit-summary-header_left_logo" src="../../assets/logo/color.svg" />
      <div class="visit-summary-header_left-texts">
        <span>
          {{ $t("visits.summary.dateIssued") }}
        </span>
        <span class="visit-summary-header_left-texts--bold">
          {{ visitDate }}
        </span>
      </div>
    </v-col>
    <v-col class="visit-summary-header_right">
      <span v-for="address of addresses" :key="address">{{ address }}</span>
    </v-col>
  </v-row>
</template>
<script>
import { DateTime } from "luxon";
import { mapGetters } from "vuex";
export default {
  name: "VisitSummaryHeader",
  computed: {
    ...mapGetters("visitNote", ["appointmentId"]),
    ...mapGetters("encounters", ["currentEncounter"]),
    visitDate() {
      return DateTime.fromISO(this.currentEncounter.start).toFormat("d/M/yyyy");
    },
    addresses() {
      return ["Big Binary LLC", "350 SW 148th Ave", "Miramar FL 33027", "United States"];
    },
  },
};
</script>
<style lang="scss">
.visit-summary-header {
  padding: 30px;

  &_left {
    height: 100px;
    &_logo {
      max-width: 112px;
      height: 32px;
    }
    &-texts {
      margin-top: 26px;
      margin-bottom: 3px;
      &--bold {
        font-weight: 550;
      }
    }
  }

  &_right {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: flex-end;

    span {
      margin-top: 3px;
    }
  }
}
</style>
